import { NgModule } from '@angular/core';
import {
	BciCardModule,
	BciFormMsgModule,
	BciSpinnerModule,
	BciWkButtonModule,
	BciWkCheckboxModule,
	BciWkInputMoneyModule,
	BciWkInputPhoneModule,
	BciWkInputTextModule,
	BciWkModalModule,
	BciWkSelectModule,
	BciWkSnackbarsModule,
	BciWkStepperHorizontalModule,
	BciWkTypographyModule,
	BciWkDatepickerModule,
	BciTableModule,
	BciWkAlertModule,
} from '@bci/webkitbci';

@NgModule({
	imports: [
		BciWkTypographyModule,
		BciCardModule,
		BciWkStepperHorizontalModule,
		BciSpinnerModule,
		BciFormMsgModule,
		BciWkSelectModule,
		BciWkInputMoneyModule,
		BciWkInputTextModule,
		BciWkInputPhoneModule,
		BciWkButtonModule,
		BciWkCheckboxModule,
		BciWkSnackbarsModule,
		BciWkDatepickerModule,
		BciWkModalModule,
		BciTableModule,
		BciWkAlertModule,
	],
	exports: [
		BciWkTypographyModule,
		BciCardModule,
		BciWkStepperHorizontalModule,
		BciSpinnerModule,
		BciFormMsgModule,
		BciWkSelectModule,
		BciWkInputMoneyModule,
		BciWkInputTextModule,
		BciWkInputPhoneModule,
		BciWkButtonModule,
		BciWkCheckboxModule,
		BciWkSnackbarsModule,
		BciWkDatepickerModule,
		BciWkModalModule,
		BciTableModule,
		BciWkAlertModule,
	],
})
export class BciWkModule {}
